import Abstract from "../../abstract-view/abstract.js";

import {
  MORE_ITEM
} from "../lexicon.js";

const createListItemTemplate = () => {
  return (
    `<li class="header-menu-list__item">
      <a class="header-menu-list__link header-menu-list__link_category" tabindex="0">
        ${MORE_ITEM}
        <span class="header-menu-list__button"></span>
      </a>
      <ul class="header-menu-sub-list"></ul>
    </li>`
  );
};

import {
  createElement
} from "../../render/render.js";

export default class ListItem extends Abstract {
  constructor() {
    super();

    this._subMenuElement = null;
    this._linkElement = null;
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getLinkElement() {
    if (!this._linkElement) {
      this._linkElement = this._element.querySelector(`.header-menu-list__link_category`);
    }

    return this._linkElement;
  }

  getSubMenuElement() {
    if (!this._subMenuElement) {
      this._subMenuElement = this._element.querySelector(`.header-menu-sub-list`);
    }

    return this._subMenuElement;
  }

  _getTemplate() {
    return createListItemTemplate();
  }
}
